import React from 'react'
import FrameTile from '@frame/Frame/FrameTile'
import { useTempleSelectionUI } from '@frame/useTempleSelectionUI'
import { FrameTileProps } from './types'
import { useTranslation } from 'react-i18next'

type Props = {
  temple: {
    id: number | string
    name?: string
    default_code?: string
    url?: string
    plc?: string
    ftype?: string
    store_qty?: number | null
  }
  onPress?: () => void
  dropdown?: FrameTileProps['dropdown']
  isChecked?: boolean
  isSaved?: boolean
  config: {
    isSearchScreen?: boolean
  }
}

export default function TempleItem({
  temple,
  onPress,
  dropdown,
  isChecked,
  isSaved,
  // Used to display or hide the `Saved` badge and color accent. Might be extended in the future.
  config,
}: Props) {
  const { variant, badge } = useTempleSelectionUI({
    temple,
    isChecked,
    isSaved,
    isSearchScreen: config?.isSearchScreen,
  })

  const { t } = useTranslation(['common'])

  const title = temple.name || temple.default_code || String(temple.id)

  // FIXME: We are not getting any sensible data to show nice badges
  const details = [
    t('common:qtyInStore', { count: temple.store_qty ?? 0 }),
  ].filter((d) => d !== undefined)

  return (
    <FrameTile
      title={title}
      details={details}
      image={temple.url}
      variant={variant}
      badge={badge}
      checked={isChecked}
      onPress={onPress}
      dropdown={dropdown}
    />
  )
}
